export var DEFAULT = 'default';
export var EMAILREGEX = /^\S{1,65}@{1,1}\S{1,20}\.\S{2,5}$/;
export var ERROR = 'error';
export var SUCCESS = 'success';